import { render, staticRenderFns } from "./TermsAndPolicies.vue?vue&type=template&id=ad7ba64e"
import script from "./TermsAndPolicies.vue?vue&type=script&lang=js"
export * from "./TermsAndPolicies.vue?vue&type=script&lang=js"
import style0 from "./TermsAndPolicies.vue?vue&type=style&index=0&id=ad7ba64e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports